/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Meta_TitleInputs */

const en_wc_dl_meta_title = /** @type {(inputs: Wc_Dl_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft Download for Windows, Mac & Linux (Free, Official Links)`)
};

/**
* | output |
* | --- |
* | "WordCraft Download for Windows, Mac & Linux (Free, Official Links)" |
*
* @param {Wc_Dl_Meta_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_meta_title = /** @type {((inputs?: Wc_Dl_Meta_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Meta_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_meta_title(inputs)
});
export { wc_dl_meta_title as "wc.dl.meta_title" }